import { ShiftsService } from 'data/services';
import { ShiftsServiceInterface } from 'domain/services';
import { makeRemoteGetAllShifts } from 'main/factories/usecases/shifts/get-all-shifts-factory';

export const makeShiftsService = (): ShiftsServiceInterface => {
  return new ShiftsService({
    getAllShifts: makeRemoteGetAllShifts(),
  });
};
